import { FileState } from "shared/components/file/FileState";

interface FileListItemStyles {
  cardColorScheme?: string;
  secondaryTextColor?: string;
  removeIconColor?: string;
}

const defaultStyles: FileListItemStyles = {
  secondaryTextColor: "gray.500",
  removeIconColor: "gray.500",
};

export const getFileListItemStyles = (state: FileState) => {
  const stateStyles = (() => {
    switch (state) {
      case "uploading_complete":
      case "processing_complete":
        return {
          cardColorScheme: "success",
          secondaryTextColor: "primary.600",
        };
      case "uploading_failed":
      case "uploading_cancelled":
      case "processing_failed":
      case "processing_cancelled":
      case "deleted":
        return {
          cardColorScheme: "error",
          secondaryTextColor: "error.600",
          removeIconColor: "error.700",
        };
    }
  })();
  return {
    ...defaultStyles,
    ...stateStyles,
  };
};
